export const config = {
  title: '沈阳市环境卫生监管系统',
  data: [
    {
      title: '点位类型统计',
      type: 'block',
      fetch: '',
      filters: {
        queries: [
          {
            slug: 'createdAt',
            queryTypes: ['dayEqual'],
          },
        ],
        logicType: 'and',
      },
    },
    {
      title: '各区案件数量',
      type: 'pie',
      fetch: '',
    },
    {
      title: '各区案件整改数量',
      type: 'bar',
      fetch: '',
    },
    {
      title: '案件数量',
      type: 'rose',
      fetch: '',
    },
    {
      title: '问题上报情况',
      type: 'article',
      fetch: '',
    },
    {
      title: '各区整改情况',
      type: 'list',
      fetch: '',
    },
    {
      title: '地图',
      type: 'map',
      fetch: '',
    },
  ],
}

export const OSSURL = `http://ow-code.oss-cn-beijing.aliyuncs.com/ow/${process.env.REACT_APP_PROJECT}/${process.env.REACT_APP_DEP}/images`
